module.exports = ".clickable{cursor:pointer}\n"